/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Optomisitc Tanuki API
 * I got caught by an angry panda once, he said life's too short to be stuck working for someone else's dreams. I wonder if he ever got back home.
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse,
} from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

export interface CreateProfileDto {
  /** Name of the profile */
  name?: string;
  /** Description of the profile */
  description: string;
  /** User ID associated with the profile */
  userId: string;
  /** URL of the profile picture */
  profilePic: string;
  /** URL of the cover picture */
  coverPic?: string;
  /** Bio of the profile */
  bio?: string;
  /** Location of the profile */
  location?: string;
  /** Occupation of the profile */
  occupation?: string;
  /** Interests of the profile */
  interests?: string;
  /** Skills of the profile */
  skills?: string;
}

export interface UpdateProfileDto {
  /** ID of the profile */
  id?: string;
  /** Name of the profile */
  name?: string;
  /** Description of the profile */
  description?: string;
  /** User ID associated with the profile */
  userId?: string;
  /** App scope associated with the profile */
  appScope?: string;
  /** URL of the profile picture */
  profilePic?: string;
  /** URL of the cover picture */
  coverPic?: string;
  /** Bio of the profile */
  bio?: string;
  /** Location of the profile */
  location?: string;
  /** Occupation of the profile */
  occupation?: string;
  /** Interests of the profile */
  interests?: string;
  /** Skills of the profile */
  skills?: string;
}

/**
 * Type of the timeline event
 */
export type CreateTimelineDtoType =
  (typeof CreateTimelineDtoType)[keyof typeof CreateTimelineDtoType];

export const CreateTimelineDtoType = {
  AddedGoal: 'AddedGoal',
  AddedProject: 'AddedProject',
  UpdatedGoal: 'UpdatedGoal',
  UpdatedProject: 'UpdatedProject',
  CreateProfile: 'CreateProfile',
  UpdatedProfile: 'UpdatedProfile',
  CompletedGoal: 'CompletedGoal',
  CompletedProject: 'CompletedProject',
  DeletedGoal: 'DeletedGoal',
  Posted: 'Posted',
  Commented: 'Commented',
  Liked: 'Liked',
  Contributed: 'Contributed',
} as const;

export interface CreateTimelineDto {
  /** Name of the timeline */
  name: string;
  /** Description of the timeline */
  description: string;
  /** ID of the user */
  userId: string;
  /** ID of the profile */
  profileId: string;
  /** ID of the project */
  projectId: string;
  /** ID of the goal */
  goalId: string;
  /** Start date of the timeline */
  startDate: string;
  /** End date of the timeline */
  endDate: string;
  /** Completion status of the timeline */
  isCompleted: boolean;
  /** Publication status of the timeline */
  isPublished: boolean;
  /** Deletion status of the timeline */
  isDeleted: boolean;
  /** Type of the timeline event */
  type: CreateTimelineDtoType;
}

export interface UpdateTimelineDto {
  /** ID of the timeline */
  id: string;
}

export type ProfileControllerCreateProfileBody = CreateProfileDto & {
  appId?: string;
};

export type ProfileControllerSearchProfilesParams = {
  q: string;
  limit: string;
};

export type ProfileControllerGetProfilesByIdsBody = {
  ids: string[];
};

export type ProfileAnalyticsControllerRecordViewBody = {
  profileId: string;
  /** Ignored; set from authenticated account. */
  viewerId?: string;
  source: string;
};

export type ProfileAnalyticsControllerGetRecentViewersParams = {
  limit?: unknown;
};

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
    | HttpParams
    | Record<
        string,
        string | number | boolean | Array<string | number | boolean>
      >;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: { includeHeaders?: string[] } | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set()
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime())))
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({ providedIn: 'root' })
export class OptomisitcTanukiAPIService {
  private readonly http = inject(HttpClient);
  profileControllerListGuardianDependents<TData = void>(
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerListGuardianDependents<TData = void>(
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerListGuardianDependents<TData = void>(
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerListGuardianDependents<TData = void>(
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/dependents`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/dependents`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/dependents`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Create a new profile
   */
  profileControllerCreateProfile<TData = void>(
    profileControllerCreateProfileBody: ProfileControllerCreateProfileBody,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerCreateProfile<TData = void>(
    profileControllerCreateProfileBody: ProfileControllerCreateProfileBody,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerCreateProfile<TData = void>(
    profileControllerCreateProfileBody: ProfileControllerCreateProfileBody,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerCreateProfile<TData = void>(
    profileControllerCreateProfileBody: ProfileControllerCreateProfileBody,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
        `/api/profile`,
        profileControllerCreateProfileBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
        `/api/profile`,
        profileControllerCreateProfileBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.post<TData>(
      `/api/profile`,
      profileControllerCreateProfileBody,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

  /**
   * @summary Get all profiles
   */
  profileControllerGetAllProfiles<TData = void>(
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetAllProfiles<TData = void>(
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetAllProfiles<TData = void>(
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetAllProfiles<TData = void>(
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Discover profiles available for direct messages
   */
  profileControllerGetDiscoverableProfiles<TData = void>(
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetDiscoverableProfiles<TData = void>(
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetDiscoverableProfiles<TData = void>(
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetDiscoverableProfiles<TData = void>(
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/discover`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/discover`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/discover`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Get current user profile
   */
  profileControllerGetCurrentProfile<TData = void>(
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetCurrentProfile<TData = void>(
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetCurrentProfile<TData = void>(
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetCurrentProfile<TData = void>(
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/me`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/me`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/me`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Get a profile by ID
   */
  profileControllerGetProfileById<TData = void>(
    id: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetProfileById<TData = void>(
    id: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetProfileById<TData = void>(
    id: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetProfileById<TData = void>(
    id: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/by-id/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/by-id/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/by-id/${id}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  profileControllerGetDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/dependents/${profileId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/dependents/${profileId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/dependents/${profileId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  profileControllerUpdateDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerUpdateDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerUpdateDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerUpdateDependentProfile<TData = void>(
    profileId: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
        `/api/profile/dependents/${profileId}`,
        undefined,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
        `/api/profile/dependents/${profileId}`,
        undefined,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.put<TData>(
      `/api/profile/dependents/${profileId}`,
      undefined,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

  /**
   * @summary Get a profile by ID (legacy)
   */
  profileControllerSearchProfiles<TData = void>(
    params: ProfileControllerSearchProfilesParams,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerSearchProfiles<TData = void>(
    params: ProfileControllerSearchProfilesParams,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerSearchProfiles<TData = void>(
    params: ProfileControllerSearchProfilesParams,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerSearchProfiles<TData = void>(
    params: ProfileControllerSearchProfilesParams,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams(
      { ...params, ...options?.params },
      new Set<string>([])
    );

    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/search`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/search`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`/api/profile/search`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }

  profileControllerGetProfileLegacy<TData = void>(
    id: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetProfileLegacy<TData = void>(
    id: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetProfileLegacy<TData = void>(
    id: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetProfileLegacy<TData = void>(
    id: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/${id}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Update a profile by ID
   */
  profileControllerUpdateProfile<TData = void>(
    id: string,
    updateProfileDto: UpdateProfileDto,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerUpdateProfile<TData = void>(
    id: string,
    updateProfileDto: UpdateProfileDto,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerUpdateProfile<TData = void>(
    id: string,
    updateProfileDto: UpdateProfileDto,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerUpdateProfile<TData = void>(
    id: string,
    updateProfileDto: UpdateProfileDto,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`/api/profile/${id}`, updateProfileDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`/api/profile/${id}`, updateProfileDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`/api/profile/${id}`, updateProfileDto, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Delete an owned app-scoped profile by ID
   */
  profileControllerDeleteProfile<TData = unknown>(
    id: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerDeleteProfile<TData = unknown>(
    id: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerDeleteProfile<TData = unknown>(
    id: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerDeleteProfile<TData = unknown>(
    id: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(`/api/profile/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`/api/profile/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.delete<TData>(`/api/profile/${id}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Get profiles by IDs
   */
  profileControllerGetProfilesByIds<TData = void>(
    profileControllerGetProfilesByIdsBody: ProfileControllerGetProfilesByIdsBody,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetProfilesByIds<TData = void>(
    profileControllerGetProfilesByIdsBody: ProfileControllerGetProfilesByIdsBody,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetProfilesByIds<TData = void>(
    profileControllerGetProfilesByIdsBody: ProfileControllerGetProfilesByIdsBody,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetProfilesByIds<TData = void>(
    profileControllerGetProfilesByIdsBody: ProfileControllerGetProfilesByIdsBody,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
        `/api/profile/by-ids`,
        profileControllerGetProfilesByIdsBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
        `/api/profile/by-ids`,
        profileControllerGetProfilesByIdsBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.post<TData>(
      `/api/profile/by-ids`,
      profileControllerGetProfilesByIdsBody,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

  /**
   * @summary Create a new timeline
   */
  profileControllerCreateTimeline<TData = void>(
    createTimelineDto: CreateTimelineDto,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerCreateTimeline<TData = void>(
    createTimelineDto: CreateTimelineDto,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerCreateTimeline<TData = void>(
    createTimelineDto: CreateTimelineDto,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerCreateTimeline<TData = void>(
    createTimelineDto: CreateTimelineDto,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/api/profile/timeline`, createTimelineDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/api/profile/timeline`, createTimelineDto, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/api/profile/timeline`, createTimelineDto, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Get a timeline by ID
   */
  profileControllerGetTimeline<TData = void>(
    id: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetTimeline<TData = void>(
    id: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetTimeline<TData = void>(
    id: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetTimeline<TData = void>(
    id: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/timeline/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/timeline/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/timeline/${id}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Update a timeline by ID
   */
  profileControllerUpdateTimeline<TData = void>(
    id: string,
    updateTimelineDto: UpdateTimelineDto,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerUpdateTimeline<TData = void>(
    id: string,
    updateTimelineDto: UpdateTimelineDto,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerUpdateTimeline<TData = void>(
    id: string,
    updateTimelineDto: UpdateTimelineDto,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerUpdateTimeline<TData = void>(
    id: string,
    updateTimelineDto: UpdateTimelineDto,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
        `/api/profile/timeline/${id}`,
        updateTimelineDto,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
        `/api/profile/timeline/${id}`,
        updateTimelineDto,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.put<TData>(
      `/api/profile/timeline/${id}`,
      updateTimelineDto,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

  /**
   * @summary Delete a timeline by ID
   */
  profileControllerDeleteTimeline<TData = void>(
    id: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerDeleteTimeline<TData = void>(
    id: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerDeleteTimeline<TData = void>(
    id: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerDeleteTimeline<TData = void>(
    id: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(`/api/profile/timeline/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`/api/profile/timeline/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.delete<TData>(`/api/profile/timeline/${id}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Get blocked users for a profile
   */
  profileControllerGetBlockedUsers<TData = void>(
    id: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerGetBlockedUsers<TData = void>(
    id: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerGetBlockedUsers<TData = void>(
    id: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerGetBlockedUsers<TData = void>(
    id: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile/${id}/blocked`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile/${id}/blocked`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile/${id}/blocked`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Block a user
   */
  profileControllerBlockUser<TData = void>(
    id: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerBlockUser<TData = void>(
    id: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerBlockUser<TData = void>(
    id: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerBlockUser<TData = void>(
    id: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/api/profile/${id}/block`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/api/profile/${id}/block`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/api/profile/${id}/block`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Unblock a user
   */
  profileControllerUnblockUser<TData = void>(
    id: string,
    blockedProfileId: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileControllerUnblockUser<TData = void>(
    id: string,
    blockedProfileId: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileControllerUnblockUser<TData = void>(
    id: string,
    blockedProfileId: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileControllerUnblockUser<TData = void>(
    id: string,
    blockedProfileId: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
        `/api/profile/${id}/block/${blockedProfileId}`,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
        `/api/profile/${id}/block/${blockedProfileId}`,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.delete<TData>(
      `/api/profile/${id}/block/${blockedProfileId}`,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

  /**
   * @summary Record a profile view
   */
  profileAnalyticsControllerRecordView<TData = void>(
    profileAnalyticsControllerRecordViewBody: ProfileAnalyticsControllerRecordViewBody,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileAnalyticsControllerRecordView<TData = void>(
    profileAnalyticsControllerRecordViewBody: ProfileAnalyticsControllerRecordViewBody,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileAnalyticsControllerRecordView<TData = void>(
    profileAnalyticsControllerRecordViewBody: ProfileAnalyticsControllerRecordViewBody,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileAnalyticsControllerRecordView<TData = void>(
    profileAnalyticsControllerRecordViewBody: ProfileAnalyticsControllerRecordViewBody,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
        `/api/profile-analytics/view`,
        profileAnalyticsControllerRecordViewBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
        `/api/profile-analytics/view`,
        profileAnalyticsControllerRecordViewBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.post<TData>(
      `/api/profile-analytics/view`,
      profileAnalyticsControllerRecordViewBody,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

  /**
   * @summary Get profile view statistics
   */
  profileAnalyticsControllerGetViewStats<TData = void>(
    profileId: string,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileAnalyticsControllerGetViewStats<TData = void>(
    profileId: string,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileAnalyticsControllerGetViewStats<TData = void>(
    profileId: string,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileAnalyticsControllerGetViewStats<TData = void>(
    profileId: string,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/api/profile-analytics/${profileId}/stats`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/api/profile-analytics/${profileId}/stats`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/api/profile-analytics/${profileId}/stats`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }

  /**
   * @summary Get recent profile viewers
   */
  profileAnalyticsControllerGetRecentViewers<TData = void>(
    profileId: string,
    params?: ProfileAnalyticsControllerGetRecentViewersParams,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  profileAnalyticsControllerGetRecentViewers<TData = void>(
    profileId: string,
    params?: ProfileAnalyticsControllerGetRecentViewersParams,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  profileAnalyticsControllerGetRecentViewers<TData = void>(
    profileId: string,
    params?: ProfileAnalyticsControllerGetRecentViewersParams,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  profileAnalyticsControllerGetRecentViewers<TData = void>(
    profileId: string,
    params?: ProfileAnalyticsControllerGetRecentViewersParams,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams(
      { ...params, ...options?.params },
      new Set<string>([])
    );

    if (options?.observe === 'events') {
      return this.http.get<TData>(
        `/api/profile-analytics/${profileId}/viewers`,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
          params: filteredParams,
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
        `/api/profile-analytics/${profileId}/viewers`,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
          params: filteredParams,
        }
      );
    }

    return this.http.get<TData>(`/api/profile-analytics/${profileId}/viewers`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
}
